import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useLenisSmooth } from "@/lib/lenisSmooth";
import { usePageTitle } from "@/lib/usePageTitle";
import { Nav } from "@/components/fina/Nav";
import { Hero } from "@/components/fina/Hero";
import { Heritage } from "@/components/fina/Heritage";
import { Capabilities } from "@/components/fina/Capabilities";
import { Sectors } from "@/components/fina/Sectors";
import { Signature } from "@/components/fina/Signature";
import { Clients } from "@/components/fina/Clients";
import { Contact } from "@/components/fina/Contact";
import { Footer } from "@/components/fina/Footer";
import { InMotion } from "@/components/fina/InMotion";
import { Cursor } from "@/components/fina/Cursor";
import { ScrollProgress } from "@/components/fina/ScrollProgress";
import Careers from "@/pages/Careers";

const Home = () => {
  useLenisSmooth();
  usePageTitle("Fina Engineering | Stainless Steel Fabrication & Engineering");
  return (
    <div
      className="relative bg-[#09090b] text-white min-h-screen"
      data-testid="home-page"
    >
      <Cursor />
      <ScrollProgress />
      <Nav />
      <main>
        <Hero />
        <Heritage />
        <Capabilities />
        <Sectors />
        <InMotion />
        <Signature />
        <Clients />
        <Contact />
      </main>
      <Footer />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#121214",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.08)",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/careers" element={<Careers />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
